import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useNotificationsCenterStore = defineStore('notificationsCenter', {
  state,
  getters,
  actions
})

export default useNotificationsCenterStore
